import React from 'react';

export const MentionNodeToken = ({
  iconComponent: IconComponent,
  label,
}: {
  iconComponent?: React.ComponentType;
  label: string;
}) => {
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        fontWeight: '500',
        gap: '8px',
        verticalAlign: 'text-bottom',
      }}
    >
      {IconComponent && <IconComponent />}
      <span>{label}</span>
    </span>
  );
};
